/* THIS FILE IS GENERATED ON RUNTIME. DO NOT EDIT */

module.exports = { 
  typography: ["headline-3xl","headline-2xl","headline-xl","headline-lg","headline-md","headline-sm","headline-xs","headline-2xs","headline-3xs","preamble-lg","preamble-md","preamble-sm","body-lg","body-md","body-sm","body-xs","quote-md","quote-sm","input-lg","input-md","input-sm","input-xs","ui-md","ui-sm"],
  prose: ["factbox","coverbox"],
};